import { tVProgramShowed } from '@kinopoisk-int/evgen-web-events/web/tv_program';

import { useEventCallback } from '@/scenarios/legacy-player/hooks/analytics/use-event-callback';

import { buildChannelProgramModalParams } from '../builders/channel-program-modal-params-builder';

interface Options {
    channelId: string;
}
export function useChannelProgramShowed(uiParams: Options) {
    return useEventCallback({
        event: tVProgramShowed,
        eventParamsBuilder: buildChannelProgramModalParams,
        uiParams,
    });
}
